// extracted by mini-css-extract-plugin
export default {"playerCentredNavigation":"styles__playerCentredNavigation--5un_i"};